import { expValEqualsNoExposure } from '@confluence/feature-experiments';
import { componentWithCondition } from '@confluence/feature-gating-utils';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorControlsBanner as EditorControlsBannerSync } from './EditorControlsBanner';

const EditorControlsBannerAsync = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditorControlsBanner" */ './EditorControlsBanner'))
			.EditorControlsBanner,
});

export const EditorControlsBannerLoader = componentWithCondition(
	() => expValEqualsNoExposure('platform_editor_controls_performance_fixes', 'isEnabled', true),
	EditorControlsBannerSync,
	EditorControlsBannerAsync,
);
